export const EXTERNAL_LOGIN_URL = "https://www.lex.com.br/sistema/auth";
